import { PageProps } from "@/types/page";
import { usePage } from "@/utils/turboSafeInertia";
import axios from "axios";
import { PropsWithChildren, useContext, useEffect, useState } from "react";
import { AnalyticsContext } from "./AnalyticsContext";
import {
    initialPopoverContext,
    PopoverContext,
    PopoverId,
} from "./PopoverContext";

export function PopoverProvider({ children }: PropsWithChildren) {
    const { user, twoFactorPassed } = usePage<PageProps>().props;

    const analytics = useContext(AnalyticsContext);

    const [arePopoversInitialized, setArePopoversInitialized] = useState(
        initialPopoverContext.arePopoversInitialized,
    );
    const [popoverIdsShown, setPopoverIdsShown] = useState(
        initialPopoverContext.popoverIdsShown,
    );

    const markPopoverAsShown = (
        popoverId: PopoverId,
        temporary: boolean = false,
    ) => {
        setPopoverIdsShown(new Set([...popoverIdsShown, popoverId]));
        analytics.trackEvent("popover_dismissed", {
            popover_id: popoverId,
            temporary,
        });
        if (!temporary) {
            axios.post(route("popovers.markAsShown", { popoverId }));
        }
    };

    const loadUnseenPopovers = () => {
        axios.get(route("popovers.index")).then((response) => {
            setPopoverIdsShown(new Set(response.data));
            setArePopoversInitialized(true);
        });
    };

    useEffect(() => {
        if (!user || !twoFactorPassed) {
            setPopoverIdsShown(new Set<PopoverId>());
            setArePopoversInitialized(false);
        } else {
            loadUnseenPopovers();
        }
    }, [user?.type, user?.id, twoFactorPassed]);

    return (
        <PopoverContext.Provider
            value={{
                arePopoversInitialized,
                popoverIdsShown,
                markPopoverAsShown,
            }}
        >
            {children}
        </PopoverContext.Provider>
    );
}
